module.exports = __webpack_public_path__ + "img/close.7f0c894b.png";